import { DynamicFormField } from '@/common/form/formFields/DynamicFormField';
import { withConditionalRender } from '@/common/form/higherOrderComponents/withConditionalRender';
import { EntityForm } from '@/common/entityFramework/entityForm/EntityForm';
import { PolPeriodSelect } from './formFields/PolPeriodSelect';
import { PolPeriodicitySelect } from './formFields/PolPeriodicitySelect';
import { useRsrc } from '@/common/rsrc/RsrcContext';
import { useEffect, useState } from 'react';

export const PolForm = () => {

  const rsrc = useRsrc();
  
  const [polTypeToPeriodicity, setPolTypeToPeriodicity] = useState();

  useEffect(() => {
    rsrc.data('gp', 'POL_FORM_PERIODICITY_ENUM_DATA_PLUGIN').then((polTypeToPeriodicity) => {
      setPolTypeToPeriodicity(polTypeToPeriodicity);
    })
  }, []);

  const augFieldDefs = (fieldToFieldDef) => {

    // Periodicity has special logic
    fieldToFieldDef.periodicity.component = (
      <PolPeriodicitySelect 
      key="periodicity" 
      fieldDef={fieldToFieldDef.periodicity}
      polTypeToPeriodicity={polTypeToPeriodicity}
      />
    )

    // Period Selects which are dependent on periodicity
    fieldToFieldDef.startPeriodId.component = <PolPeriodSelect key="startPeriodId" fieldDef={fieldToFieldDef.startPeriodId} />
    fieldToFieldDef.endPeriodId.component = <PolPeriodSelect key="endPeriodId" fieldDef={fieldToFieldDef.endPeriodId} />

    // Validators for startPeriod and endPeriod
    fieldToFieldDef.startPeriodId.validators = [(value, formValues) => {
      const startPeriodCode = formValues.startPeriodCode;
      const endPeriodCode = formValues.endPeriodCode;

      if (startPeriodCode && endPeriodCode && startPeriodCode > endPeriodCode) {
        return 'Start Period must come before End Period';
      }
      
      return null;
    }]

    fieldToFieldDef.endPeriodId.validators = [(value, formValues) => {
      const startPeriodCode = formValues.startPeriodCode;
      const endPeriodCode = formValues.endPeriodCode;

      if (startPeriodCode && endPeriodCode && startPeriodCode > endPeriodCode) {
        return 'End Period must come after Start Period';
      }
      
      return null;
    }]

    // Some fields are conditionally rendered based on the polType    
    const VisibleIfNotBundle = withConditionalRender((formValues) => formValues.type !== 'BUNDLE')(DynamicFormField);
    const VisibleIfBundle = withConditionalRender((formValues) => formValues.type === 'BUNDLE')(DynamicFormField);

    fieldToFieldDef.authGenLinkDirection.component = <VisibleIfNotBundle key="authGenLinkDirection" fieldDef={fieldToFieldDef.authGenLinkDirection} />
    fieldToFieldDef.relabelLinkDirection.component = <VisibleIfNotBundle key="relabelLinkDirection" fieldDef={fieldToFieldDef.relabelLinkDirection} />
    fieldToFieldDef.customPackLinkDirection.component = <VisibleIfNotBundle key="customPackLinkDirection" fieldDef={fieldToFieldDef.customPackLinkDirection} />

    fieldToFieldDef.ctrtId.component = <VisibleIfBundle key="ctrtId" fieldDef={fieldToFieldDef.ctrtId} />
  }

  if (!polTypeToPeriodicity) {
    return null;
  }

  return (
    <EntityForm augFieldDefs={augFieldDefs} />
  )
}